
const Title = ({children}) => {
  return (
    <div className="left-sidebar-title">
      <span>{children}</span>
    </div>
  )
}

export default Title
